import React from "react";
import { createInheritedProvider } from "../utils/create-inherited-provider";
export var defaultAppConfig = {
  includeProfile: false,
  profilePath: '/app/profile',
  setupPath: '/app/setup',
  welcomePath: '/app/welcome'
};
export var AppContext = React.createContext(defaultAppConfig);
export var AppProvider = createInheritedProvider(AppContext);